<rqa-splitter [leftComponent]="leftSideComponent" [rightComponent]="rightSideComponent"></rqa-splitter>
